import { containsProtocolDelimiter, isValidProtocol } from '../helpers/url-helpers';
import { t } from '../i18n';

const validateURL = (value: string, httpsRequired = false): string => {
    if (!value) {
        return '';
    }

    let parsedUrl: URL;
    try {
        parsedUrl = new URL(value);
    } catch {
        return t('url-invalid');
    }

    if (!containsProtocolDelimiter(value)) {
        return t('url-invalid');
    }
    if (!parsedUrl.protocol || !parsedUrl.hostname) {
        return t('url-invalid');
    }
    if (!isValidProtocol(parsedUrl.protocol, httpsRequired)) {
        return t(httpsRequired ? 'url-scheme-https' : 'url-scheme-http-https');
    }

    return '';
};

export default validateURL;
